import {Log} from '@aboutyou/mlm';

import {assert} from 'ts-essentials';

export async function initializeBotModeConfig() {
  assert(
    process.browser,
    'Expected initializeBotModeConfig to be called on the client only',
  );

  const enableBotModeConfig = getServerEnableBotModeConfig(document.body);

  assert(
    enableBotModeConfig,
    "Expected enableBotMode config to be available in the client's initial markup. " +
      'Make sure it is provided via the server rendering code',
  );

  window.__ENABLE_BOT_MODE__ = enableBotModeConfig.isBotRequest;
}

function getServerEnableBotModeConfig(container: Element) {
  const enableBotMode = container.querySelector('[data-enable-bot-mode]');

  if (!enableBotMode) {
    return false;
  }

  try {
    return JSON.parse(enableBotMode.innerHTML);
  } catch (error) {
    Log.error(
      '@aboutyou/bootstrap',
      `Error parsing server enable bot mode config:`,
      {error},
    );

    return null;
  }
}

export function getServerEnableBotModeConfigOnClient(): boolean {
  return window.__ENABLE_BOT_MODE__ ?? false;
}
